module.exports = __webpack_public_path__ + "media/assets/img/products/studio_international-unavailable-98ff0f5a7ee94c06b482cb0bbe6e2313.svg";